import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CustomValidators } from './custom-validator';
export class DuplicateGovernmentIdValidator {
    static duplicateGovId(isDuplicate: boolean): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!CustomValidators.hasValue(control.value)) {
                return null;  // don't validate empty values to allow optional controls
            }else{
                if(isDuplicate){
                return {
                        'duplicateGovId': 'Government Id Already Exists'
                    }
                }else{
                    return null;
                }
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/Utils/duplicate-government-id-validator.ts